<mat-form-field class="country-width">
    <mat-label>Country</mat-label>
    <input #input type="text" matInput [required]="required" [formControl]="country" [matAutocomplete]="auto"
        (input)="filter()" (focus)="filter()">
    <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayValueFunc">
        @for (country of filteredCountries; track country) {
        <mat-option [value]="country">{{country.alpha_3_code}} - {{country.en_short_name}}</mat-option>
        }
    </mat-autocomplete>
</mat-form-field>